/**
 * Module 00 — Global Shell · Credits service (FE-00-09)
 *
 * Credits are tracked in the data-service. `GET /credits/summary` returns the
 * org's consumed/remaining/total credits for the sidebar footer meter. Goes
 * through the Bearer-only data-service client so the service resolves the real
 * user + organization.
 */

import { dataServiceClient } from '@/lib/api/dataservice-client';

export interface CreditsSummary {
  organization_id: string;
  plan: string;
  used: number;
  remaining: number;
  total: number;
  subscription_credits: number;
  top_up_credits: number;
}

export const creditsService = {
  getSummary(organizationId: string): Promise<CreditsSummary> {
    return dataServiceClient.get<CreditsSummary>('/credits/summary', {
      params: { organization_id: organizationId },
    });
  },
};
